import createIcon from '../../createIcon';

/**
 * @component @name IceSkating
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDhDNy41IDcuNzIgNy43MiA3LjUgOCA3LjVIMTAuNTJMMTAuNSA2LjVIOEM3LjcyIDYuNSA3LjUgNi4yOCA3LjUgNkM3LjUgNS43MiA3LjcyIDUuNSA4IDUuNUgxMC41VjIuNUgyLjVWMTcuNUg1LjVWMTkuNUgxLjVWMjEuNUgxNy41QzIwLjI2IDIxLjUgMjIuNSAxOS4yNiAyMi41IDE2LjVIMjAuNUMyMC41IDE4LjE2IDE5LjE2IDE5LjUgMTcuNSAxOS41SDE1LjVWMTcuNUgxOC41VjE0LjYyQzE4LjUgMTIuNTIgMTYuOTUgMTEuMDkgMTUuNDcgMTAuNzRMMTIuNzcgMTAuMDdDMTEuOSA5Ljg1IDExLjIgOS4yNiAxMC44MiA4LjVIOEM3LjcyIDguNSA3LjUgOC4yOCA3LjUgOFpNMTMuNSAxOS41SDcuNVYxNy41SDEzLjVWMTkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const IceSkating = createIcon('IceSkating', [
  [
    'path',
    {
      d: 'M7.5 8C7.5 7.72 7.72 7.5 8 7.5H10.52L10.5 6.5H8C7.72 6.5 7.5 6.28 7.5 6C7.5 5.72 7.72 5.5 8 5.5H10.5V2.5H2.5V17.5H5.5V19.5H1.5V21.5H17.5C20.26 21.5 22.5 19.26 22.5 16.5H20.5C20.5 18.16 19.16 19.5 17.5 19.5H15.5V17.5H18.5V14.62C18.5 12.52 16.95 11.09 15.47 10.74L12.77 10.07C11.9 9.85 11.2 9.26 10.82 8.5H8C7.72 8.5 7.5 8.28 7.5 8ZM13.5 19.5H7.5V17.5H13.5V19.5Z',
      key: '1e7g1x',
    },
  ],
]);

export default IceSkating;
